<template>
  <v-container fluid fill-height class="loginOverlay">
          <v-layout flex align-center justify-center>
            <v-flex xs12 sm4 elevation-6>
              <v-toolbar class="pt-5 blue darken-4">
                <v-toolbar-title class="white--text"><h4>Willkommen zurück</h4></v-toolbar-title>
                </v-toolbar-items>
              </v-toolbar>
              <v-card>
                <v-card-text class="pt-4">
                  <div>
                      <v-form v-model="valid" ref="form">
                        <v-text-field
                          label="E-mail"
                          v-model="email"
                          required
                        ></v-text-field>
                        <v-text-field
                          label="Passwort"
                          v-model="password"
                          min="8"
                          :append-icon="e1 ? 'visibility' : 'visibility_off'"
                          :append-icon-cb="() => (e1 = !e1)"
                          :type="e1 ? 'password' : 'text'"
                          required
                        ></v-text-field>
                        <span>{{ msg }}</span>
                        <v-layout justify-space-between>
                            <v-btn @click="submit" :class=" { 'blue darken-4 white--text' : valid, disabled: !valid }">Anmeldung</v-btn>
                        </v-layout>
                      </v-form>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
       </v-container>
</template>

<script>
import axios from 'axios';
  export default {
    data () {
      return {
        e1: 1,
        valid: false,
        password: '',
        email: '',
        msg: ''
      }
    },
    created() {
      if (this.$cookie.get('x-access-token')) {
        this.$router.go(-1)
      }
    },
    methods: {
      submit () {
        let { email, password } = this
        this.$httpClient.post('login.php', { email, password })
        .then((sessionid) => {
          if (sessionid.data.success) {
            this.$router.app.$cookie.set('x-access-token', sessionid.data.session_id)
            axios.defaults.headers.common['x-access-token'] = this.$router.app.$cookie.get('x-access-token')
            this.$router.app.$cookie.set('admin', sessionid.data.admin)
            this.$router.push('tests')
          }else {
            this.msg = this.lang.hibas_felhasznalonev_vagy_jelszo
          }
        })
      },
    }
  }
</script>
